import React, { useEffect, useState } from "react";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
import RestService from "./RestService";
import { Link } from "react-router-dom";

export default function Articles() {
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState({});

  useEffect(() => {
    setLoading(true);
    RestService.getArticlesData(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      if (parseInt(response?.status) === 201) {
        setglobaldata(response?.data?.response);
      } else {
        setglobaldata(false);
      }
    });
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}

      <GlobalHelmet {...Common?.Articles} />

      <div className="bodycontainer">
        <div className="auto-space">
          <Breadcrumbs page="Articles" />
          <div className="signalheader">
            <div className="news-original">
              <div className="row">
                <div className="clearfix"> </div>
                <div className="col-md-12 w3ls_mutual_funds_grid1_jkjk">
                  <div className="row">
                    {globaldata.rows
                      ? globaldata.rows.map((item, key) => (
                          <div className="col-sm-4 my-cont pt-3 pb-2" key={key}>
                            <section>
                              <div className="container py-5">
                                <div className="card text-black article-image">
                                  <img
                                    src={item.image}
                                    className="card-img-top"
                                    alt={item.title}
                                  />
                                  <div className="article-card-body">
                                    <div className="article-card-title ">
                                      <h6 className="">{item.title}</h6>
                                    </div>
                                    <p className="text-muted mb-4">
                                      {item.content}
                                      <Link
                                        to={`/investing/${item.slug}`}
                                        target="_blank"
                                      >
                                        {""} ...view more
                                      </Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        ))
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
